import { render, staticRenderFns } from "./AddToOrderStandardDescription.vue?vue&type=template&id=4557b82f"
import script from "./AddToOrderStandardDescription.vue?vue&type=script&lang=js"
export * from "./AddToOrderStandardDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports